
export function getReferer () {
    console.log('getReferer()', window.location.origin);
    return window.location.origin;
}
